
import { toast } from 'react-toastify';
import { getUserPermissions,getUserPermissionState } from '../crud/users_api/user_permissions';

export function fixMangledUtf8(str:string) {
    try {
        return decodeURIComponent(escape(str));
    } catch (e) {
        console.error("Failed to fix mangled UTF-8 string:", e);
        return str;
    }
}

export function getDate(text:string) {
    //'2020-02-19T00:00:00'
    if (text.includes('T') && text.includes('-')) {
    let date  = text.split('T')[0].split("-");
    let year  = date[0];
    let month = date[1];
    let day   = date[2];
    return `${day}/${month}/${year}`;
    }
}

export const uuidv4 = ():string => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      // eslint-disable-next-line no-mixed-operators
      const r = (Math.random() * 16) | 0,
        // eslint-disable-next-line no-mixed-operators
        v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

export  const formatCurrency = (value: number) => {
  // get localConfiguration from localStorage
  const localConfiguration = localStorage.getItem('localConfiguration');
  const moneda_code = localConfiguration != null ? JSON.parse(localConfiguration).moneda_code : 'CLP';
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: moneda_code }).format(value);
  };


export function formatDateTime(dateTime: string) {
  const date = new Date(dateTime);
  const timeOptions: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit' };

  // if the date is equal to today, return hoy, <time>
  if (date.toDateString() === new Date().toDateString()) {
      return 'Hoy ' + date.toLocaleTimeString(undefined, timeOptions);
  } 
  // if the date is equal to yesterday, return ayer, <time>
  else if (date.toDateString() === new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()) {
      return 'Ayer ' + date.toLocaleTimeString(undefined, timeOptions);
  } 
  // otherwise return the date and time without seconds
  else {
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString(undefined, timeOptions);
  }
}

export function getPermissionState(permission_id:number) {
  // check if userPermissions is in localStorage
  const userPermissions = localStorage.getItem('userPermissions');
  // if userPermissions is not null
  if (userPermissions != null) {
    // parse userPermissions from localStorage
    let permissions = JSON.parse(userPermissions);
    
    // Check if state check is needed (every 90 seconds - 90000 ms)
    const now = Date.now();
    const lastStateCheck = permissions.lastStateCheck || 0;
    const ninetySecondsAgo = now - 90000;
    
    if (lastStateCheck < ninetySecondsAgo) {
      // Check permission state asynchronously in the background
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      if (user && user.user_id) {
        getUserPermissionState(user.user_id)
          .then(stateResponse => {
            // Update lastStateCheck timestamp
            const updatedPermissions = {
              ...permissions,
              lastStateCheck: Date.now()
            };
            localStorage.setItem('userPermissions', JSON.stringify(updatedPermissions));
            
            // If permissions have been updated on the server, fetch the full table
            if (stateResponse.data && stateResponse.data.updated === true) {
              getUserPermissions(user.user_id)
                .then(userPermissionsResponse => {
                  // Update permissions with new data and timestamps
                  const refreshedPermissions = {
                    ...userPermissionsResponse.data,
                    lastLoaded: Date.now(),
                    lastStateCheck: Date.now()
                  };
                  
                  localStorage.setItem('userPermissions', JSON.stringify(refreshedPermissions));
  
                })
                .catch(error => {
                  console.error('Error al actualizar permisos completos:', error);
                });
            }
          })
          .catch(error => {
            toast.error('Error al verificar el estado de permisos: ' + error.message);
          });
      }
    }
    
    // check if the permission_id exists in the permissions object
    if (permissions[permission_id]) {
      // return the enabled state of the permission
      const perm = permissions[permission_id];
      if (perm !== null && perm !== undefined) {
        return perm.enabled;
      }
    }
    else {
      // return false if the permission_id does not exist
      return false;
    }
  }
  else {
    // return false if userPermissions is null
    return false;
  }
}

export function isSuperAdmin() {
  // get the user from localStorage
  const user = localStorage.getItem('user');
  if (user) {
    // parse the user object
    const userObj = JSON.parse(user);
    // check if the user is a super admin
    if (userObj.rol_id === 1) {
      return true;
    } else {
      return false;
    }
  }
  else {
    return false;
  }
}

